import React from 'react';
import { add_new } from '../../assets/images/dashboard-business';

const StatusHeader = () => {
  return (
    <div>
      <div className='flex justify-between flex-wrap gap-2 items-center'>
        <div>
          <div className='text-[#028789] font-[600] text-[16px] font-[Poppins]'>
            Your Business registration status
          </div>
          <div className='text-xs'>View the status of your business registration</div>
        </div>
      </div>
      <hr className='w-[100%] my-3' />
    </div>
  );
};

export default StatusHeader;
